export default __webpack_public_path__ + "static/media/title.0c2923a2.svg";